const unique = (v, i, a) => a.indexOf(v) === i;
const emptyString = (v) => v.trim() !== '';

export { unique, emptyString };